// extracted by mini-css-extract-plugin
module.exports = {"message":"messagebox_message__1XtNv"};